
import { eRewardType } from '@/interface/prize';
import { UserModule } from '@/store/modules/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() prizeType!: object[];
  @Prop() model!: any;
  @Prop({ default: false }) isDisabled!: boolean;
  @Prop({ default: true }) isShowNameUnit!: boolean;
  @Prop() isShowDay!: boolean;
  free: eRewardType = eRewardType.FREE;
  no: eRewardType = eRewardType.NO;
  coin: eRewardType = eRewardType.COIN;
  cash: eRewardType = eRewardType.CASH;
  weekCard: eRewardType = eRewardType.WEEKCARD;
  ios: eRewardType = eRewardType.IOS;
  activeBrand = UserModule.activeBrand;
  get getUnit() {
    let value = '';
    switch (this.model.reward_type) {
      case this.cash:
        value = '现金券';
        break;
      case this.ios:
        value = 'min game time';
        break;
      case this.weekCard:
        value = '周期卡';
        break;
      default:
        value = '';
    }
    return value;
  }
}
